import React from 'react';
import './Input.css';

const Select = ({
  title,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  error,
  className = "",
  options = [],
  ...props
}) => {
  return (
    <div className={`input-container ${className}`}>
      {title && (
        <label className="input-title">
          {title}
          {required && <span className="required-asterisk">*</span>}
        </label>
      )}
      <select
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className={`input-field select-field ${error ? 'input-error' : ''}`}
        {...props}
      >
        <option value="">{placeholder || 'Select an option'}</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <div className="input-error-message">
          {error}
        </div>
      )}
    </div>
  );
};

export default Select; 